var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "-5 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-256 -89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M275,113h9v-2a8.024,8.024,0,0,0-8-8h-1Z",
    fill: "#7d50f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M294,129a4,4,0,0,1-4-4V110.5c0-6.315-4.85-11.617-11.369-13.083a5,5,0,1,0-7.251.012C264.855,98.947,260,104.447,260,111v14a4,4,0,0,1-4,4v2h12.08a6.991,6.991,0,0,0,13.84,0H294ZM275,91a2.993,2.993,0,0,1,1,5.816V94h-2v2.816A2.993,2.993,0,0,1,275,91Zm0,44a5.009,5.009,0,0,1-4.9-4h2.083a2.982,2.982,0,0,0,5.632,0H279.9A5.009,5.009,0,0,1,275,135Zm-14.532-6A5.976,5.976,0,0,0,262,125V111c0-6.617,5.832-12,13-12s13,5.159,13,11.5V125a5.976,5.976,0,0,0,1.532,4Z",
    fill: "#303033"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.08be250a47b42251843ead151e1045a8.svg";
export { ForwardRef as ReactComponent };